const actionNeeded = {
  background: '#E7F8F4',
  borderClass: 'border-teal-200',
  labelClass: 'bg-white/85 text-teal-700 border-teal-200',
  badgeClass: 'bg-teal-100 text-teal-700',
  iconClass: 'text-teal-500',
};

const waiting = {
  background: '#EEEBFF',
  borderClass: 'border-indigo-200',
  labelClass: 'bg-white/85 text-indigo-600 border-indigo-200',
  badgeClass: 'bg-indigo-100 text-indigo-600',
  iconClass: 'text-indigo-400',
};

const completed = {
  background: '#E8F8EF',
  borderClass: 'border-emerald-200',
  labelClass: 'bg-white/85 text-emerald-700 border-emerald-200',
  badgeClass: 'bg-emerald-100 text-emerald-700',
  iconClass: 'text-emerald-500',
};

const closed = {
  background: '#FDECEE',
  borderClass: 'border-rose-200',
  labelClass: 'bg-white/85 text-rose-600 border-rose-200',
  badgeClass: 'bg-rose-100 text-rose-600',
  iconClass: 'text-rose-400',
};

export const focusTheme = {
  header: {
    background: 'linear-gradient(90deg, #2DD4BF 0%, #0D9488 100%)',
    boxShadow: '4px 5px 11px rgba(0, 0, 0, 0.07)',
  },
  sectionBg: 'rgba(204, 251, 241, 0.38)',
  accent: '#0D9488',
  stat: {
    remaining: '#CCFBF1',
    completed: '#D1FAE5',
  },
  status: {
    submitted: completed,
    published: actionNeeded,
    active: actionNeeded,
    upcoming: waiting,
    expired: closed,
    finished: closed,
  },
  card: {
    base: 'border text-slate-800',
    disabled: 'opacity-80',
  },
  badge: {
    index: actionNeeded.badgeClass,
  },
  meta: {
    chip: 'rounded-[4px] bg-white/85 px-2 py-1 text-slate-700',
    status: 'rounded-[4px] border px-2 py-1 text-center font-semibold',
  },
  button: {
    primary: 'bg-[#00C0B9] text-white border-b-[2px] border-b-[#008F8A]',
    secondary: 'bg-teal-100 text-teal-800 border-b-[2px] border-b-teal-300',
    retry: 'bg-[#00C0B9] text-white',
    submit:
      'bg-[#00C0B9] text-white border-b-[3px] border-b-[#008F8A] shadow-[0_4px_12px_rgba(0,192,185,0.35)]',
  },
  question: {
    answered: '#E8F8EF',
    unanswered: '#E7F8F4',
  },
  option: {
    selected: 'border-teal-300 bg-teal-50 text-teal-900',
    unselected: 'border-teal-100 bg-white text-slate-700',
    selectedBadge: 'bg-teal-500 text-white',
    unselectedBadge: 'bg-teal-100 text-teal-700',
    correct: 'border-emerald-300 bg-emerald-50 text-emerald-900',
    correctBadge: 'bg-emerald-500 text-white',
    incorrect: 'border-rose-300 bg-rose-50 text-rose-900',
    incorrectBadge: 'bg-rose-500 text-white',
  },
  message: {
    success: 'text-teal-700',
    error: 'text-rose-600',
  },
  submitted: {
    cardBorder: completed.borderClass,
    cardBg: completed.background,
    badge: 'bg-emerald-400 text-white',
    banner: 'bg-emerald-50 border border-emerald-200',
    bannerText: 'text-emerald-700',
    bannerIcon: 'text-emerald-500',
  },
  contentType: {
    pdf: {
      label: 'PDF',
      badgeClass: 'bg-rose-100 text-rose-600',
    },
    image: {
      label: 'تصویر',
      badgeClass: 'bg-violet-100 text-violet-600',
    },
    video: {
      label: 'ویدیو',
      badgeClass: 'bg-orange-100 text-orange-600',
    },
    link: {
      label: 'لینک',
      badgeClass: 'bg-sky-100 text-sky-600',
    },
    other: {
      label: 'محتوا',
      badgeClass: 'bg-teal-100 text-teal-700',
    },
  },
};

export function getListCardProps(statusKey, { disabled = false } = {}) {
  const status = focusTheme.status[statusKey] || focusTheme.status.active;

  return {
    status,
    className: `flex flex-col gap-2 rounded-[5px] p-2 border ${status.borderClass} text-slate-800${
      disabled ? ` ${focusTheme.card.disabled}` : ''
    }${disabled ? ' cursor-not-allowed' : ''}`,
    style: { background: status.background },
  };
}
